// Temporary feature flags
// Toggle to disable the account dashboard experience globally
export const DASHBOARD_DISABLED = false;

// Whitelist of users allowed to access the dashboard while disabled
export const DASHBOARD_WHITELIST_EMAILS: string[] = [
  'vaynerov@icloud.com',
  'meizzuzurq@gmail.com'
];

// Returns true if the dashboard is allowed given current disable flag and user email
export function isDashboardAllowed(userEmail?: string | null): boolean {
  if (!DASHBOARD_DISABLED) return true;
  const email = (userEmail || '').toLowerCase();
  return !!email && DASHBOARD_WHITELIST_EMAILS.includes(email);
}

// Returns true if user should have full access to all dashboard tabs
export function hasDashboardFullAccess(userEmail?: string | null): boolean {
  const email = (userEmail || '').toLowerCase();
  return !!email && DASHBOARD_WHITELIST_EMAILS.includes(email);
}


